import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Scene} from "phaser";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";
import {Tr} from "@/i18n/i18n";

export class HeroExchangeConfirmationPanel extends VerticalStandardPanel {
    constructor(scene: Scene,
                canvas: HTMLCanvasElement,
                onConfirm: () => void) {
        super(scene, canvas, Tr('hero.exchange'));
        this.setDepth(6001);

        let clickSound = SoundUtils.addSound(this.scene!, Keys.SOUND_BUTTON_CLICK);

        let confirmText = TextUtils.addTextByFamily(
            scene, Tr('hero.exchange.confirmation'),
            0, -50, '#ffffff', 16, 'normal', 360,
            Fonts.MYRIADPRO_REGULAR
        );

        let declineButton = new SquareButton(
            scene, -100, 135, 0,
            Keys.UI_ART_BROWN_BUTTON,
            Keys.ATLAS_PROFILE,
            Keys.UI_DECLINE_CROSS,
            Tr('no_cancel'),
            false
        );

        let acceptButton = new SquareButton(
            scene, 100,
            135, 0,
            Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE,
            Keys.UI_GOLDEN_CHECK,
            Tr('yes_confirm'),
            false, 80, 80
        );

        acceptButton.setCallback(() => {
            SoundUtils.play(clickSound);
            onConfirm();
            this.close();
        });
        declineButton.setCallback(() => {
            SoundUtils.play(clickSound);
            this.close();
        });

        this.add([confirmText, declineButton, acceptButton]);
    }
}